export default "__VITE_ASSET__acc09414__"